<template>
  <el-dialog title="Reset Password" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <el-form ref="form" :model="ruleForm" :rules="rules" v-loading="form_loading"  label-position="top">
      <el-form-item label="New Password" prop="password">
        <el-input v-model="ruleForm.password" type="password" :show-password="true" placeholder="New Password"></el-input>
      </el-form-item>
      <el-form-item label="Confirm Password" prop="password2">
        <el-input v-model="ruleForm.password2" type="password" :show-password="true" placeholder="Confirm Password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="background-color: #034844;border-color:#034844;" @click="submitForm">Reset</el-button>
        <el-button @click="visible = false">Cancel</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import { getActionApi } from '@/network/manageApi';
import moment from 'moment/moment';
import { postAction } from '@/network/manage';
export default {
  name: 'ResetPassword',
  components: {},
  data() {
    return {
      dialogWidth:'600px',
      visible:false,
      ruleForm:{
        password:'',
        password2:''
      },
      rules: {
        password: [
          { required: true, message: 'Password is required',trigger: 'blur'},
          { pattern:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]])[A-Za-z\d`~!@#$%^&*()_+<>?:"{},.\/\\;'[\]]{6,18}$/, message: 'combinations of alphanumeric and special symbols within 6 to 18 characters',trigger: 'blur'}
        ],
        password2: [
          { required: true, message: 'Confirm Password is required',trigger: 'blur'},
          {
            validator: (rules, value, callback) => {
                if (value !== this.ruleForm.password) callback(new Error('Passwords do not match.'))
                callback()
            },trigger: 'blur'
          }
        ],
      },
      form_loading: false,
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    moment,
    init() {
      this.visible = true
      this.form_loading = false
      this.ruleForm = {
        password:'',
        password2:''
      }
    },
    submitForm() {
      const that = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.form_loading = true
          postAction('/admin/accountManagement/resetPasswordMy',{password:that.ruleForm.password}).then((res) => {
            if(res.success){
              that.$message({
                message: 'reset success!',
                type: 'success'
              });
              that.visible = false
            }else{
              that.$message.error(res.message);
            }
          }).catch((err) => {
            that.$message.error(err.message);
          }).finally((res) => {
            that.form_loading = false
          });
        }
      });
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 600 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .form{display: grid;grid-template-columns:1fr 1fr;}
  .form .flex{display: flex;justify-content: space-between;min-height:60px;align-items: center;font-size: 14px;}
  .border{border-bottom: 1px solid #EDF2F7;}
  .left{border-right: 1px solid #EDF2F7;padding-right:30px;margin-right: 30px;}
  .form a{font-size: 18px;font-weight: bold;color: #5856D6;width: 100%;text-align: center;}
  .el-form-item {margin-bottom: 40px;}
  >>>.el-dialog__header{border-bottom:1px solid #dddddd;padding:15px 20px;}
  >>>.el-dialog__body{padding:20px;}
  >>>.el-form-item__label{line-height: 1;}
  h1{font-size: 18px;margin:20px 0;}
  b{font-size: 18px;}
  p{font-size: 14px;}
  .label{display:flex;}
  .label span{margin:0 10px 10px 0;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
  }
</style>
